import { render } from "./WelcomeText.vue?vue&type=template&id=2fddb114&scoped=true&lang=true"
import script from "./WelcomeText.vue?vue&type=script&lang=js"
export * from "./WelcomeText.vue?vue&type=script&lang=js"

import "./WelcomeText.vue?vue&type=style&index=0&id=2fddb114&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fddb114"]])

export default __exports__